document.addEventListener("DOMContentLoaded", () => {
  try {
    const dataEl = document.getElementById("customer-data");
    if (!dataEl) return;

    const { tags } = JSON.parse(dataEl.textContent);

    if (tags.includes("consultant")) {
      console.log("1111");

      const el = document.querySelector('[class="_19gi7yt0 _19gi7ytq _19gi7ytj _1fragemv5 _19gi7yt16 _19gi7yt1e _19gi7yt1p _1fragem3h"]');
      if (el && el.parentElement) {
        el.parentElement.style.display = 'none';
      }

      // Also handle the Recharge portal referral widget
      if (window.location.pathname.includes('/tools/recurring/portal')) {
        const observer = new MutationObserver(() => {
          const el = document.querySelector('[data-testid="refer-a-friend"]');
          if (el) {
            el.style.display = 'none';
            observer.disconnect();
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    }
  } catch (e) {
    console.error(e);
  }
});